module.exports = __webpack_public_path__ + "img/5.2f6b172d.webp";